import React, { useState } from "react";
import toast from "react-hot-toast";
import { Card, Form, Input } from "antd";
import api from "../../api/index.js";
import LoadableButton from "../../components/button/LoadableButton";

const Contact = () => {
  const [form] = Form.useForm();
  const [isLoading, setIsLoading] = useState(false);

  const onFinish = async (values) => {
    setIsLoading(true);
    try {
      const { data } = await api.post("contact-us", values);
      if (data?.status) toast.success("Thank you for contacting us!");
    } catch (error) {
      if (error?.response?.data?.message)
        toast.error(error?.response?.data?.message);
    } finally {
      form.resetFields();
      setIsLoading(false);
    }
  };

  return (
    <div className="bg-primary bg-opacity-10">
      <div className="container mx-auto h-screen px-5 py-10 flex items-center justify-center">
        <Card className="w-[600px]">
          <h2 className="font-semibold text-center text-2xl mb-5">
            Contact Us
          </h2>

          <Form form={form} layout="vertical" onFinish={onFinish} size="large">
            <Form.Item
              label="Name"
              name="name"
              rules={[{ required: true, message: "Please enter name" }]}
            >
              <Input placeholder="Enter name" />
            </Form.Item>

            <div className="grid grid-cols-2 max-sm:grid-cols-1 gap-5 max-sm:gap-0">
              <Form.Item
                label="Email"
                name="email"
                rules={[
                  { required: true, message: "Please enter email" },
                  { type: "email", message: "Please enter a valid email" },
                ]}
              >
                <Input placeholder="Enter email" />
              </Form.Item>
              <Form.Item
                label="Phone"
                name="phone"
                rules={[
                  { required: true, message: "Please enter phone number" },
                  {
                    pattern: /^\d{10}$/,
                    message: "Phone number should be 10 digits!",
                  },
                ]}
              >
                <Input type="number" placeholder="Enter phone number" />
              </Form.Item>
            </div>

            <Form.Item
              label="Message"
              name="message"
              rules={[{ required: true, message: "Please enter message" }]}
            >
              <Input.TextArea rows={5} placeholder="Enter message" />
            </Form.Item>

            <LoadableButton
            className="w-full flex justify-center"
              type="submit"
              lable="Submit"
              isLoading={isLoading}
              loadingLable="Submitting..."
            />
          </Form>
        </Card>
      </div>
    </div>
  );
};

export default Contact;
